import { render, staticRenderFns } from "./IdentityVerificationProcessing.vue?vue&type=template&id=05a3d2dd"
import script from "./IdentityVerificationProcessing.vue?vue&type=script&lang=js"
export * from "./IdentityVerificationProcessing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports